import { useAuthStore } from '@/stores/auth';

/**
 * Accounts (accountant) can open People to read, but the server refuses to
 * create / edit / delete employees or logins for them (N2, 2026-10-18), so the
 * page must not offer those buttons.
 */
export function useCanWritePeople(): boolean {
  const role = useAuthStore((s) => s.user?.role?.name);
  return String(role ?? '').toLowerCase() !== 'accountant';
}
